import React from "react";

const Loading = ({ width,beforeWidth , beforeHeight, height, color, margin }) => {

  return (
    <div className={`dot-wrapper flex justify-center items-center ${height ? height : "h-11"} ${margin}`}>
      <div className={`dot ${color ? color : "before:bg-[#2f52ef]"} ${beforeWidth} ${beforeHeight} ${width}`}></div>
      <div className={`dot ${color ? color : "before:bg-[#2f52ef]"} ${beforeWidth} ${beforeHeight} ${width}`}></div>
      <div className={`dot ${color ? color : "before:bg-[#2f52ef]"} ${beforeWidth} ${beforeHeight} ${width}`}></div>
    </div>
  );
};

export default Loading;
